import api from 'Cloud/Application/api';
import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import { apiMigrateWeblinksV2ToV4 } from 'reactApp/appHelpers/featuresHelpers';
import { promisifyDeferredCall } from 'reactApp/utils/helpers';

const method = 'weblinks/clone';

type WeblinksCloneApiCallParams = {
    weblink: string;
    folder: string;
    conflict?: 'rename' | 'rewrite';
};

class WeblinksCloneAPIV4Call extends APICallV4 {
    _method = method;
    _type: Method = 'post';
}

export const weblinksCloneApiCall = (params: WeblinksCloneApiCallParams): Promise<unknown> => {
    if (apiMigrateWeblinksV2ToV4.clone) {
        return new WeblinksCloneAPIV4Call().makeRequest(params).then((response) => response?.data?.body);
    }

    return promisifyDeferredCall(api.clone, params);
};
